import { CompetitionsMatchCardSchema } from './CompetitionsMatchCard.styles';

export const competitionsMatchCardStyles: CompetitionsMatchCardSchema = {
  vsBoxWrapper: {
    position: 'relative',
    p: '1',
  },
  vsDivider: {
    borderColor: '#222',
    opacity: '0.2',
    ml: '5',
  },
  absoluteCenter: {
    px: '2',
    left: '2',
    ml: '1px',
    fontWeight: 'semibold',
    color: 'beta.300',
    fontFamily: 'accent',
    textTransform: 'uppercase',
    fontSize: 'xs',
  },
  matchCardOverride: {
    mb: '2',
  },
  propositionButtonOverride: {
    w: '100%',
  },
  gridItem: {
    w: '100%',
  },
  flexWrapper: {
    alignItems: 'center',
  },
  flexText: {
    as: 'span',
    flex: '1',
    textAlign: 'left',
    fontFamily: 'accent',
    fontSize: 'xs',
    fontWeight: 'semibold',
    textTransform: 'uppercase',
    color: 'white',
  },
  gridWrapper: {
    gap: 2,
  },
  propositionButtonOverrideSecondary: {
    w: ['50px', '100px'],
    px: ['0', null, 'inherit'],
  },
  gridItemTextNoProposition: {
    w: ['50px', '100px'],
    h: 'full',
    minH: '10',
    textAlign: 'center',
    color: 'white',
    fontFamily: 'accent',
    textShadow: '0px 2px 3px rgba(0, 0, 0, 0.30)',
    fontWeight: 'bold',
    fontSize: 'xs',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'base',
    border: '2px',
    borderColor: 'blackAlpha.300',
  },
  flexAwayTeam: {
    alignItems: 'center',
  },
  flexAwayTeamText: {
    flex: '1',
    textAlign: 'left',
    color: 'white',
    fontFamily: 'accent',
    fontSize: 'xs',
    fontWeight: 'semibold',
    textTransform: 'uppercase',
  },
};
